__turbopack_context__.v({
  "active": "StoriesBanner-module-scss-module__Y-LEGa__active",
  "activeNavDot": "StoriesBanner-module-scss-module__Y-LEGa__activeNavDot",
  "activeSlide": "StoriesBanner-module-scss-module__Y-LEGa__activeSlide",
  "cityCrown": "StoriesBanner-module-scss-module__Y-LEGa__cityCrown",
  "cityPair": "StoriesBanner-module-scss-module__Y-LEGa__cityPair",
  "completed": "StoriesBanner-module-scss-module__Y-LEGa__completed",
  "contentBody": "StoriesBanner-module-scss-module__Y-LEGa__contentBody",
  "contentCta": "StoriesBanner-module-scss-module__Y-LEGa__contentCta",
  "contentHeading": "StoriesBanner-module-scss-module__Y-LEGa__contentHeading",
  "contentLabel": "StoriesBanner-module-scss-module__Y-LEGa__contentLabel",
  "contentPanel": "StoriesBanner-module-scss-module__Y-LEGa__contentPanel",
  "contentPanelBackground": "StoriesBanner-module-scss-module__Y-LEGa__contentPanelBackground",
  "contentPanelInner": "StoriesBanner-module-scss-module__Y-LEGa__contentPanelInner",
  "contentPanelOverlay": "StoriesBanner-module-scss-module__Y-LEGa__contentPanelOverlay",
  "header": "StoriesBanner-module-scss-module__Y-LEGa__header",
  "headerContent": "StoriesBanner-module-scss-module__Y-LEGa__headerContent",
  "headerCta": "StoriesBanner-module-scss-module__Y-LEGa__headerCta",
  "headerLabel": "StoriesBanner-module-scss-module__Y-LEGa__headerLabel",
  "headerTitle": "StoriesBanner-module-scss-module__Y-LEGa__headerTitle",
  "noStories": "StoriesBanner-module-scss-module__Y-LEGa__noStories",
  "progressBar": "StoriesBanner-module-scss-module__Y-LEGa__progressBar",
  "progressBars": "StoriesBanner-module-scss-module__Y-LEGa__progressBars",
  "progressFill": "StoriesBanner-module-scss-module__Y-LEGa__progressFill",
  "reversed": "StoriesBanner-module-scss-module__Y-LEGa__reversed",
  "section": "StoriesBanner-module-scss-module__Y-LEGa__section",
  "slideNav": "StoriesBanner-module-scss-module__Y-LEGa__slideNav",
  "slideNavDot": "StoriesBanner-module-scss-module__Y-LEGa__slideNavDot",
  "storyBackground": "StoriesBanner-module-scss-module__Y-LEGa__storyBackground",
  "storyBackgroundColor": "StoriesBanner-module-scss-module__Y-LEGa__storyBackgroundColor",
  "storyBottom": "StoriesBanner-module-scss-module__Y-LEGa__storyBottom",
  "storyCard": "StoriesBanner-module-scss-module__Y-LEGa__storyCard",
  "storyContent": "StoriesBanner-module-scss-module__Y-LEGa__storyContent",
  "storyCta": "StoriesBanner-module-scss-module__Y-LEGa__storyCta",
  "storyExcerpt": "StoriesBanner-module-scss-module__Y-LEGa__storyExcerpt",
  "storyOverlay": "StoriesBanner-module-scss-module__Y-LEGa__storyOverlay",
  "storyPanel": "StoriesBanner-module-scss-module__Y-LEGa__storyPanel",
  "storySlide": "StoriesBanner-module-scss-module__Y-LEGa__storySlide",
  "storySlides": "StoriesBanner-module-scss-module__Y-LEGa__storySlides",
  "storyTitle": "StoriesBanner-module-scss-module__Y-LEGa__storyTitle",
  "worldClock": "StoriesBanner-module-scss-module__Y-LEGa__worldClock",
  "worldClockImage": "StoriesBanner-module-scss-module__Y-LEGa__worldClockImage",
  "worldClockLarge": "StoriesBanner-module-scss-module__Y-LEGa__worldClockLarge",
  "worldClockSvg": "StoriesBanner-module-scss-module__Y-LEGa__worldClockSvg",
});
